<!-- DIAS Customization Start -->
<div *ishFeature="'dotCmsUve'; else icmContent">
  <!-- <custom-lazy-dot-cms-footer /> -->
  <!-- <custom-dot-cms-uve-footer /> -->
  <ng-container *ngComponentOutlet="lazyFooterComponent$ | async" />
</div>
<!-- DIAS Customization End -->
<ng-template #icmContent>
  <ng-container *ishHasNotRole="['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER']">
    <!-- <ish-lazy-store-locator-footer></ish-lazy-store-locator-footer> -->
    <ish-lazy-content-include includeId="include.footer.content.pagelet2-Include" />
  </ng-container>
</ng-template>
<!-- DIAS Customization Start -->
<ish-back-to-top />
<!-- DIAS Customization End -->
<!--
<ng-container *ishHasNotRole="['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER']">
  <ish-lazy-store-locator-footer />
  <div class="footer">
    <div class="container">
      <div [ishServerHtml]="'footer.disclaimer' | translate" class="clearfix"></div>
      <ish-lazy-content-include includeId="include.footer.content.pagelet2-Include" />
      <div [ishServerHtml]="'footer.copyright' | translate : { appVersion: appVersion }" class="clearfix"></div>
    </div>
  </div>
</ng-container>
 -->
